const videoPlayer = {
    init() {
        let playIcons = document.querySelectorAll('.embed-play-icon');

        playIcons.forEach(function(playIcon) {
            const videoUrl = playIcon.getAttribute('data-url');

            playIcon.onclick = function(){
                playIcon.parentNode.innerHTML = '<iframe frameborder="0" class="embed-responsive-item" src="' + videoUrl + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>'
            };
        });
    }
}

videoPlayer.init();